<template>
    <q-dialog v-model="modal"
              transition-show="slide-up"
              transition-hide="slide-down"
              :maximized="$q.platform.is.mobile">
        <q-card class="modal-city modal-40">
            <div class="modal-header">
                <span class="modal-title">Выбор города</span>
                <div class="modal-close" @click="modal=false">
                    <span aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             x="0px" y="0px" width="10px"
                             height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                            <path d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                </div>
            </div>
            <q-card-section class="modal-content">
                <span class="link mr-4" @click.prevent="autoDetect">
                    Определить автоматически
                </span>
                <span v-if="!useRegion" class="link" @click.prevent="useRegion = true">Моего города нет в списке</span>
                <div class="row">
                    <div v-if="useRegion" class="col">
                        <q-select
                            clearable
                            square
                            outlined
                            hide-selected
                            fill-input
                            use-input
                            input-debounce="350"
                            :value="form.region.id"
                            @input="setRegion"
                            option-value="id"
                            option-label="label"
                            :options="regionOptions"
                            :options-dense="true"
                            @filter="searchRegion"
                            emit-value
                            map-options
                            behavior="menu"
                            hide-dropdown-icon
                            :label="useRegion ? 'Введите область/край' : null"
                            :error-message="form.errors.get('region.name')"
                            :error="form.errors.has('region.name')">
                            <template v-slot:no-option>
                                <q-item>
                                    <q-item-section class="text-grey">
                                        Ничего не найдено
                                    </q-item-section>
                                </q-item>
                            </template>
                            <template v-slot:append>
                                <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.7586 14.4721L11.1103 10.7169C12.0483 9.61333 12.5623 8.22479 12.5623 6.77927C12.5623 3.40196 9.78581 0.65419 6.3732 0.65419C2.96059 0.65419 0.184113 3.40196 0.184113 6.77927C0.184113 10.1566 2.96059 12.9044 6.3732 12.9044C7.65434 12.9044 8.87521 12.5219 9.91901 11.796L13.5951 15.5797C13.7487 15.7376 13.9554 15.8247 14.1768 15.8247C14.3865 15.8247 14.5853 15.7456 14.7363 15.6018C15.057 15.2963 15.0673 14.7898 14.7586 14.4721ZM6.3732 2.25204C8.89566 2.25204 10.9477 4.2829 10.9477 6.77927C10.9477 9.27565 8.89566 11.3065 6.3732 11.3065C3.85074 11.3065 1.79866 9.27565 1.79866 6.77927C1.79866 4.2829 3.85074 2.25204 6.3732 2.25204Z" fill="#999999"/>
                                </svg>
                            </template>
                        </q-select>
                    </div>

                    <div class="col">
                        <q-select
                            input-debounce="350"
                            clearable
                            square
                            outlined
                            hide-selected
                            fill-input
                            use-input
                            :value="form.city.id"
                            @input="setCity"
                            option-value="id"
                            option-label="label"
                            :options="cityOptions"
                            :options-dense="true"
                            @filter="citySearch"
                            emit-value
                            map-options
                            hide-dropdown-icon
                            behavior="menu"
                            :label="useRegion ? 'Введите город/посёлок' : 'Введите Ваш регион'"
                            :error-message="form.errors.get('city.name')"
                            :error="form.errors.has('city.name')">
                            <template v-slot:no-option>
                                <q-item>
                                    <q-item-section>
                                        {{ noCityResults ? 'Ничего не найдено' : 'Введите первые буквы поиска' }}
                                    </q-item-section>
                                </q-item>
                            </template>
                            <template v-slot:selected-item="scope">
                                {{ scope.name }}
                            </template>
                            <template v-slot:append>
                                <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.7586 14.4721L11.1103 10.7169C12.0483 9.61333 12.5623 8.22479 12.5623 6.77927C12.5623 3.40196 9.78581 0.65419 6.3732 0.65419C2.96059 0.65419 0.184113 3.40196 0.184113 6.77927C0.184113 10.1566 2.96059 12.9044 6.3732 12.9044C7.65434 12.9044 8.87521 12.5219 9.91901 11.796L13.5951 15.5797C13.7487 15.7376 13.9554 15.8247 14.1768 15.8247C14.3865 15.8247 14.5853 15.7456 14.7363 15.6018C15.057 15.2963 15.0673 14.7898 14.7586 14.4721ZM6.3732 2.25204C8.89566 2.25204 10.9477 4.2829 10.9477 6.77927C10.9477 9.27565 8.89566 11.3065 6.3732 11.3065C3.85074 11.3065 1.79866 9.27565 1.79866 6.77927C1.79866 4.2829 3.85074 2.25204 6.3732 2.25204Z" fill="#999999"/>
                                </svg>
                            </template>
                        </q-select>
                    </div>
                </div>
                <ul>
                    <li v-for="(cityData) in sortedCities" @click.prevent="selectCity(cityData)">
                        <span v-if="cityData.highlight">
                            <strong>{{ cityData.city.name }}</strong>
                        </span>
                        <span v-else>{{ cityData.city.name }}</span>
                    </li>
                </ul>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import location from '../../mixins/location';
import {Form} from '../../classes/Form';
import {mapState} from 'vuex';

export default {
    name: 'SelectCity',
    mixins: [
        location,
    ],
    data() {
        return {
            skipWatcher: false,
            noCityResults: 1,
            emptyFormData: {
                region: {
                    id: '',
                    name: '',
                    type_short: '',
                    zip: '',
                },
                city: {
                    id: '',
                    name: '',
                    type_short: '',
                    zip: '',
                },
                district: {
                    id: '',
                    name: '',
                    type_short: '',
                    zip: '',
                },
                with_deliveries: false,
            },
            form: new Form({
                region: {
                    id: '',
                    name: '',
                    type_short: '',
                    zip: '',
                },
                city: {
                    id: '',
                    name: '',
                    type_short: '',
                    zip: '',
                },
                district: {
                    id: '',
                    name: '',
                    type_short: '',
                    zip: '',
                },
                with_deliveries: false,
            }),
            citiesPosition: [
                "7700000000000",
                "7800000000000",
                "6600000100000",
                "5500000100000"
            ],
            cities: [
                {
                    city: {
                        id: "7700000000000",
                        name: "Москва",
                        type_short: "г",
                        guid: "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
                        zip: 111674
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "7700000000000",
                        name: "Москва",
                        type_short: "г",
                        guid: "0c5b2444-70a0-4932-980c-b4dc0d3f02b5"
                    },
                    option: [{
                        "id": "7700000000000",
                        "name": "Москва",
                        "zip": 123182,
                        "type": "Город",
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": []
                    }],
                    highlight: true,
                },
                {
                    city: {
                        id: "7800000000000",
                        name: "Санкт-Петербург",
                        type_short: "г",
                        guid: "c2deb16a-0330-4f05-821f-1d09c93331e6",
                        zip: 190000
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "7800000000000",
                        name: "Санкт-Петербург",
                        type_short: "г",
                        guid: "c2deb16a-0330-4f05-821f-1d09c93331e6"
                    },
                    option: [{
                        "id": "7800000000000",
                        "name": "Санкт-Петербург",
                        "zip": 190000,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": []
                    }],
                    highlight: true,
                },
                {
                    city: {
                        id: "6600000100000",
                        name: "Екатеринбург",
                        type_short: "г",
                        guid: "2763c110-cb8b-416a-9dac-ad28a55b4402",
                        zip: 620033
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "6600000000000",
                        name: "Свердловская",
                        type_short: "обл",
                        guid: "92b30014-4d52-4e2e-892d-928142b924bf"
                    },
                    option: [{
                        "id": "6600000100000",
                        "name": "Екатеринбург",
                        "zip": 624054,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "6600000000000",
                            "name": "Свердловская",
                            "zip": 620000,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }],
                    highlight: true,
                },
                {
                    city: {
                        id: "5500000100000",
                        name: "Омск",
                        type_short: "г",
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "5500000000000",
                        name: "Омская",
                        type_short: "обл",
                    },
                    option: [{
                        "id": "5500000100000",
                        "name": "Омск",
                        "zip": 644009,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "5500000000000",
                            "name": "Омская",
                            "zip": 644009,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }],
                    highlight: true,
                },
                {
                    city: {
                        id: "5000003600000",
                        name: "Балашиха",
                        type_short: "г",
                        guid: "27c5bc66-61bf-4a17-b0cd-ca0eb64192d6",
                        zip: 143900
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "5000000000000",
                        name: "Московская",
                        type_short: "обл",
                        guid: "29251dcf-00a1-4e34-98d4-5c47484a36d4"
                    },
                    option: [{
                        "id": "5000003600000",
                        "name": "Балашиха",
                        "zip": 143916,
                        "type": "Город",
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": []
                    }]
                },
                {
                    city: {
                        id: "5000002400000",
                        name: "Подольск",
                        type_short: "г",
                        guid: "b22cf685-e391-42c8-aab5-a9aadb9193d4",
                        zip: 142100
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "5000000000000",
                        name: "Московская",
                        type_short: "обл",
                        guid: "29251dcf-00a1-4e34-98d4-5c47484a36d4"
                    },
                    option: [{
                        "id": "5000002400000",
                        "name": "Подольск",
                        "zip": 142100,
                        "type": "Город",
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": []
                    }]
                },
                {
                    city: {
                        id: "2200000100000",
                        name: "Барнаул",
                        type_short: "г",
                        guid: "d13945a8-7017-46ab-b1e6-ede1e89317ad",
                        zip: 656004
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "2200000000000",
                        name: "Алтайский",
                        type_short: "край",
                        guid: "8276c6a1-1a86-4f0d-8920-aba34d4cc34a"
                    },
                    option: [{
                        "id": "2200000100000",
                        "name": "Барнаул",
                        "zip": 656004,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "2200000000000",
                            "name": "Алтайский",
                            "zip": 658076,
                            "typeShort": "край",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "6300000100000",
                        name: "Самара",
                        type_short: "г",
                        guid: "bb035cc3-1dc2-4627-9d25-a1bf2d4b936b",
                        zip: 443082
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "6300000000000",
                        name: "Самарская",
                        type_short: "обл",
                        guid: "df3d7359-afa9-4aaa-8ff9-197e73906b1c"
                    },
                    option: [{
                        "id": "6300000100000",
                        "name": "Самара",
                        "zip": 443082,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "6300000000000",
                            "name": "Самарская",
                            "zip": 443082,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "2500000100000",
                        name: "Владивосток",
                        type_short: "г",
                        guid: "7b6de6a5-86d0-4735-b11a-499081111af8",
                        zip: 690041
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "2500000000000",
                        name: "Приморский",
                        type_short: "край",
                        guid: "43909681-d6e1-432d-b61f-ddac393cb5da"
                    },
                    option: [{
                        "id": "2500000100000",
                        "name": "Владивосток",
                        "zip": 690001,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "2500000000000",
                            "name": "Приморский",
                            "zip": 690001,
                            "typeShort": "край",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "6400000100000",
                        name: "Саратов",
                        type_short: "г",
                        guid: "bf465fda-7834-47d5-986b-ccdb584a85a6",
                        zip: 410003
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "6400000000000",
                        name: "Саратовская",
                        type_short: "обл",
                        guid: "df594e0e-a935-4664-9d26-0bae13f904fe"
                    },
                    option: [{
                        "id": "6400000100000",
                        "name": "Саратов",
                        "zip": 410003,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "6400000000000",
                            "name": "Саратовская",
                            "zip": 410000,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "5400000100000",
                        name: "Новосибирск",
                        type_short: "г",
                        guid: "8dea00e3-9aab-4d8e-887c-ef2aaa546456",
                        zip: 630132
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "5400000000000",
                        name: "Новосибирская",
                        type_short: "обл",
                        guid: "1ac46b49-3209-4814-b7bf-a509ea1aecd9"
                    },
                    option: [{
                        "id": "5400000100000",
                        "name": "Новосибирск",
                        "zip": 630132,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "5400000000000",
                            "name": "Новосибирская",
                            "zip": 630132,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "3400000100000",
                        name: "Волгоград",
                        type_short: "г",
                        guid: "a52b7389-0cfe-46fb-ae15-298652a64cf8",
                        zip: 400038
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "3400000000000",
                        name: "Волгоградская",
                        type_short: "обл",
                        guid: "da051ec8-da2e-4a66-b542-473b8d221ab4"
                    },
                    option: [{
                        "id": "3400000100000",
                        "name": "Волгоград",
                        "zip": 400038,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "3400000000000",
                            "name": "Волгоградская",
                            "zip": 400038,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "9200000000000",
                        name: "Севастополь",
                        type_short: "г",
                        guid: "6fdecb78-893a-4e3f-a5ba-aa062459463b",
                        zip: 299011
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "9200000000000",
                        name: "Севастополь",
                        type_short: "г",
                        guid: "6fdecb78-893a-4e3f-a5ba-aa062459463b"
                    },
                    option: [{
                        "id": "9200000000000",
                        "name": "Севастополь",
                        "zip": 299011,
                        "type": "Город",
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": []
                    }]
                },
                {
                    city: {
                        id: "2400000100000",
                        name: "Красноярск",
                        type_short: "г",
                        guid: "9b968c73-f4d4-4012-8da8-3dacd4d4c1bd",
                        zip: 660001
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "2400000000000",
                        name: "Красноярский",
                        type_short: "край",
                        guid: "db9c4f8b-b706-40e2-b2b4-d31b98dcd3d1"
                    },
                    option: [{
                        "id": "2400000100000",
                        "name": "Красноярск",
                        "zip": 660001,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "2400000000000",
                            "name": "Красноярский",
                            "zip": 660001,
                            "typeShort": "край",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "3600000100000",
                        name: "Воронеж",
                        type_short: "г",
                        guid: "5bf5ddff-6353-4a3d-80c4-6fb27f00c6c1",
                        zip: 394031
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "3600000000000",
                        name: "Воронежская",
                        type_short: "обл",
                        guid: "b756fe6b-bbd3-44d5-9302-5bfcc740f46e"
                    },
                    option: [{
                        "id": "3600000400000",
                        "name": "Воронеж-45",
                        "zip": 394045,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "3600000000000",
                            "name": "Воронежская",
                            "zip": 394031,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "9100000700000",
                        name: "Симферополь",
                        type_short: "г",
                        guid: "b9001e55-72ed-43bf-b7eb-41b86a14380e",
                        zip: 295051
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "9100000000000",
                        name: "Крым",
                        type_short: "Респ",
                        guid: "bd8e6511-e4b9-4841-90de-6bbc231a789e"
                    },
                    option: [{
                        "id": "9100000700000",
                        "name": "Симферополь",
                        "zip": 295051,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "9100000000000",
                            "name": "Крым",
                            "zip": 298320,
                            "typeShort": "Респ",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "3800000300000",
                        name: "Иркутск",
                        type_short: "г",
                        guid: "8eeed222-72e7-47c3-ab3a-9a553c31cf72",
                        zip: 664002
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "3800000000000",
                        name: "Иркутская",
                        type_short: "обл",
                        guid: "6466c988-7ce3-45e5-8b97-90ae16cb1249"
                    },
                    option: [{
                        "id": "3800000300000",
                        "name": "Иркутск",
                        "zip": 664020,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "3800000000000",
                            "name": "Иркутская",
                            "zip": 666304,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "2600000100000",
                        name: "Ставрополь",
                        type_short: "г",
                        guid: "2a1c7bdb-05ea-492f-9e1c-b3999f79dcbc",
                        zip: 355016
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "2600000000000",
                        name: "Ставропольский",
                        type_short: "край",
                        guid: "327a060b-878c-4fb4-8dc4-d5595871a3d8"
                    },
                    option: [{
                        "id": "2600000100000",
                        "name": "Ставрополь",
                        "zip": 355016,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "2600000000000",
                            "name": "Ставропольский",
                            "zip": 355016,
                            "typeShort": "край",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "2300000100000",
                        name: "Краснодар",
                        type_short: "г",
                        guid: "7dfa745e-aa19-4688-b121-b655c11e482f",
                        zip: 350062
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "2300000000000",
                        name: "Краснодарский",
                        type_short: "край",
                        guid: "d00e1013-16bd-4c09-b3d5-3cb09fc54bd8"
                    },
                    option: [{
                        "id": "2300000100000",
                        "name": "Краснодар",
                        "zip": 350000,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "2300000000000",
                            "name": "Краснодарский",
                            "zip": 350000,
                            "typeShort": "край",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "4200000900000",
                        name: "Кемерово",
                        type_short: "г",
                        guid: "94bb19a3-c1fa-410b-8651-ac1bf7c050cd",
                        zip: 650002
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "4200000000000",
                        name: "Кемеровская",
                        type_short: "обл",
                        guid: "393aeccb-89ef-4a7e-ae42-08d5cebc2e30"
                    },
                    option: [{
                        "id": "4200000900000",
                        "name": "Кемерово",
                        "zip": 650002,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "4200000000000",
                            "name": "Кемеровская",
                            "zip": 652472,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "8600001000000",
                        name: "Сургут",
                        type_short: "г",
                        guid: "f1eb1809-47d4-4f0b-9a74-fa416e9d3df2",
                        zip: 628401
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "8600000000000",
                        name: "Ханты-Мансийский Автономный округ - Югра",
                        type_short: "АО",
                        guid: "d66e5325-3a25-4d29-ba86-4ca351d9704b"
                    },
                    option: [{
                        "id": "8600001000000",
                        "name": "Сургут",
                        "zip": 650002,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "8600000000000",
                            "name": "Ханты-Мансийский Автономный округ - Югра",
                            "zip": 652472,
                            "typeShort": "АО",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "5200000100000",
                        name: "Нижний Новгород",
                        type_short: "г",
                        guid: "555e7d61-d9a7-4ba6-9770-6caa8198c483",
                        zip: 603069
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "5200000000000",
                        name: "Нижегородская",
                        type_short: "обл",
                        guid: "88cd27e2-6a8a-4421-9718-719a28a0a088"
                    },
                    option: [{
                        "id": "5200000100000",
                        "name": "Нижний Новгород",
                        "zip": 603069,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "5200000000000",
                            "name": "Нижегородская",
                            "zip": 603069,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "4500000100000",
                        name: "Курган",
                        type_short: "г",
                        guid: "3bbda77d-ba3f-4457-9d44-c440815cda89",
                        zip: 640000
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "4500000000000",
                        name: "Курганская",
                        type_short: "обл",
                        guid: "4a3d970f-520e-46b9-b16c-50d4ca7535a8"
                    },
                    option: [{
                        "id": "4500000100000",
                        "name": "Курган",
                        "zip": 640001,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "4500000000000",
                            "name": "Курганская",
                            "zip": 625000,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "7200000100000",
                        name: "Тюмень",
                        type_short: "г",
                        guid: "9ae64229-9f7b-4149-b27a-d1f6ec74b5ce",
                        zip: 625000
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "7200000000000",
                        name: "Тюменская",
                        type_short: "обл",
                        guid: "54049357-326d-4b8f-b224-3c6dc25d6dd3"
                    },
                    option: [{
                        "id": "7200000100000",
                        "name": "Тюмень",
                        "zip": 625000,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "7200000000000",
                            "name": "Тюменская",
                            "zip": 625000,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "6100000100000",
                        name: "Ростов-на-Дону",
                        type_short: "г",
                        guid: "c1cfe4b9-f7c2-423c-abfa-6ed1c05a15c5",
                        zip: 344068
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "6100000000000",
                        name: "Ростовская",
                        type_short: "обл",
                        guid: "f10763dc-63e3-48db-83e1-9c566fe3092b"
                    },
                    option: [{
                        "id": "6100000100000",
                        "name": "Ростов-на-Дону",
                        "zip": 344068,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "6100000000000",
                            "name": "Ростовская",
                            "zip": 344068,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "5000004400000",
                        name: "Мытищи",
                        type_short: "г",
                        guid: "5f290be7-14ff-4ccd-8bc8-2871a9ca9d5f",
                        zip: 141001
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "5000000000000",
                        name: "Московская",
                        type_short: "обл",
                        guid: "29251dcf-00a1-4e34-98d4-5c47484a36d4"
                    },
                    option: [{
                        "id": "5000004400000",
                        "name": "Мытищи",
                        "zip": 141001,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "5000000000000",
                            "name": "Московская",
                            "zip": 452000,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "2700000100000",
                        name: "Хабаровск",
                        type_short: "г",
                        guid: "a4859da8-9977-4b62-8436-4e1b98c5d13f",
                        zip: 680009
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "2700000000000",
                        name: "Хабаровский",
                        type_short: "край",
                        guid: "7d468b39-1afa-41ec-8c4f-97a8603cb3d4"
                    },
                    option: [{
                        "id": "2700000100000",
                        "name": "Хабаровск",
                        "zip": 680014,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "2700000000000",
                            "name": "Хабаровский",
                            "zip": 452000,
                            "typeShort": "край",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "0200000100000",
                        name: "Уфа",
                        type_short: "г",
                        guid: "7339e834-2cb4-4734-a4c7-1fca2c66e562",
                        zip: 450019
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "0200000000000",
                        name: "Башкортостан",
                        type_short: "Респ",
                        guid: "6f2cbfd8-692a-4ee4-9b16-067210bde3fc"
                    },
                    option: [{
                        "id": "0200000100000",
                        "name": "Уфа",
                        "zip": 450019,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "0200000000000",
                            "name": "Башкортостан",
                            "zip": 452000,
                            "typeShort": "Респ",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "5900000100000",
                        name: "Пермь",
                        type_short: "г",
                        guid: "a309e4ce-2f36-4106-b1ca-53e0f48a6d95",
                        zip: 614025
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "5900000000000",
                        name: "Пермский",
                        type_short: "край",
                        guid: "4f8b1a21-e4bb-422f-9087-d3cbf4bebc14"
                    },
                    option: [{
                        "id": "5900000100000",
                        "name": "Пермь",
                        "zip": 614025,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "5900000000000",
                            "name": "Пермский",
                            "zip": 614575,
                            "typeShort": "край",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "7600000100000",
                        name: "Ярославль",
                        type_short: "г",
                        guid: "6b1bab7d-ee45-4168-a2a6-4ce2880d90d3",
                        zip: 150033
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "7600000000000",
                        name: "Ярославская",
                        type_short: "обл",
                        guid: "a84b2ef4-db03-474b-b552-6229e801ae9b"
                    },
                    option: [{
                        "id": "7600000100000",
                        "name": "Ярославль",
                        "zip": 150033,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "7600000000000",
                            "name": "Ярославская",
                            "zip": 150033,
                            "typeShort": "обл",
                            "contentType": "region"
                        }]
                    }]
                },
                {
                    city: {
                        id: "1600000100000",
                        name: "Казань",
                        type_short: "г",
                        guid: "93b3df57-4c89-44df-ac42-96f05e9cd3b9",
                        zip: 420032
                    },
                    district: {id: "", name: "", type_short: ""},
                    region: {
                        id: "1600000000000",
                        name: "Татарстан",
                        type_short: "Респ",
                        guid: "0c089b04-099e-4e0e-955a-6bf1ce525f1a"
                    },
                    option: [{
                        "id": "1600000100000",
                        "name": "Казань",
                        "zip": 420032,
                        "typeShort": "г",
                        "contentType": "city",
                        "parents": [{
                            "id": "1600000000000",
                            "name": "Татарстан",
                            "zip": 420000,
                            "typeShort": "Респ",
                            "contentType": "region"
                        }]
                    }]
                },
            ],
        }
    },
    mounted() {
        this.initLocationOptions();
    },
    watch: {
        'form.city.id'(newValue) {
            if (newValue && !this.skipWatcher) {
                let _this = this;

                _this.form.with_deliveries = _this.loadDeliveryDataOnCityChange;

                _this.form.put('/location')
                    .then(response => {
                        if (response.redirect) {
                            window.location.href = window.location.protocol + '//' + response.redirect + window.location.href.replace(window.location.origin, "");
                        }

                        let location = _this.form.data();

                        // add timezone to location
                        if (response.timezone) {
                            location.timezone = response.timezone;
                        }

                        _this.$store.commit('geo/setLocation', location);
                        _this.$store.commit('delivery/setLocation', location);

                        if (response.deliveries) {
                            _this.$store.commit('delivery/addDeliveries', response.deliveries);
                        }

                        if (response.pickupPoints) {
                            _this.$store.commit('delivery/setPickupPoints', response.pickupPoints);
                        }

                        if (response.stores) {
                            _this.$store.commit('delivery/setStores', response.stores);
                        }

                        if (response.maxAllowedItemsCount) {
                            _this.$store.commit('cart/setMaxAllowedItemsCount', response.maxAllowedItemsCount);
                        }

                        if (response.cartProducts) {
                            _this.$store.commit('cart/setItems', response.cartProducts);
                        }

                        _this.modal = false;
                    });
            }
        },

        modal (newValue) {
            if (newValue) {
                this.useRegion = false;

                this.form.reset();
            }
        }
    },
    methods: {
        getLocationForm() {
            return this.form;
        },
        selectCity(cityData) {
            let _this = this;

            this.$store.commit('delivery/setLocation', cityData);

            cityData.with_deliveries = this.form.with_deliveries;

            _this.setOptions('city', cityData.option)

            _this.$nextTick(function () {
                _this.form.fill(cityData);
            });

            _this.form.fill(cityData);
        },

        citySearch(val, update, abort) {
            val = val ? val : '';

            this.noCityResults = val ? 1 : 0;

            this.searchCity(val, update, abort);
        },

        autoDetect() {
            let _this = this;

            _this.form.reset();

            axios.post('/location/detect', {
                with_deliveries: _this.loadDeliveryDataOnCityChange,
            })
                .then(response => {
                    if (response.data.location) {
                        _this.skipWatcher = true;

                        if (response.data.cityOptions) {
                            _this.setOptions('city', response.data.cityOptions);
                        }

                        _this.form.fill(response.data.location);

                        this.$store.commit('delivery/setLocation', response.data.location);

                        _this.$store.commit('geo/setLocation', response.data.location);

                        if (response.data.pickupPoints) {
                            _this.$store.commit('delivery/setPickupPoints', response.data.pickupPoints);
                        }

                        if (response.data.maxAllowedItemsCount) {
                            _this.$store.commit('cart/setMaxAllowedItemsCount', response.data.maxAllowedItemsCount);
                        }

                        _this.$nextTick(function () {
                            _this.skipWatcher = false;
                        });

                        setTimeout(function () {
                            _this.modal = false;
                        }, 200);
                    }
                });
        },
    },
    computed: {
        ...mapState('geo', [
            'loadDeliveryDataOnCityChange',
        ]),
        modal: {
            get() {
                return this.$store.state.geo.modal;
            },
            set(value) {
                this.$store.commit('geo/hideModal');
            }
        },
        sortedCities () {
            const cities = _.sortBy(this.cities.filter(i => !i.highlight), item => item.city.name);
            const highlighted = this.cities.filter(i => i.highlight);

            if (!cities.length) {
                return [];
            }

            const columnsCount = this.$q.screen.width < 991.98 ? 2 : 3;

            let columnsData = [];
            let data = [];

            for (let i = 0; i < highlighted.length; i++) {
                cities.splice(i, 0, highlighted[i]);
            }

            const recordsPerColumn = Math.ceil(cities.length / columnsCount);

            for (let i = 0; i < columnsCount; i++) {
                columnsData[i] = cities.slice(i * recordsPerColumn, i * recordsPerColumn + recordsPerColumn);
            }

            for (let i = 0; i < columnsData[0].length; i++) {
                for (let j = 0; j < columnsCount; j++) {
                    if (columnsData[j][i]) {
                        data.push(columnsData[j][i]);
                    }
                }
            }

            return data;
        }
    }
}
</script>
